import {Box, SxProps, Typography} from '@mui/material';

import EmpionLabeledValue from '../EmpionLabeledValue/EmpionLabeledValue';

import {RequiredLanguageProfile} from '../../types/shared-types';

interface Props {
  title: string;
  light?: boolean;
  onDelete?: (id: string) => void;
  groups: {
    groupName?: string;
    color?: 'primary' | 'secondary';
    items: {
      id: string;
      label: string | RequiredLanguageProfile;
      value?: string;
    }[];
  }[];
  sx?: SxProps;
}

export const EmpionLabeledValueList = ({title, light, groups, onDelete}: Props) => {
  return (
    <>
      <Typography variant='h2'>{title}</Typography>
      {groups.map((group, idx) => (
        <Box
          key={group.groupName || '' + idx}
          sx={{
            mt: 2,
          }}
        >
          {group.groupName && <Typography variant='body1'>{group.groupName}</Typography>}
          {group.items.map((item, sIdx) => (
            <Box key={item.label + '' + sIdx}>
              <EmpionLabeledValue
                onDelete={onDelete ? () => onDelete(item.id) : undefined}
                light={light}
                label={item.label as string}
                value={item.value}
                color={group.color}
                sx={{
                  mt: 2,
                }}
              />
            </Box>
          ))}
        </Box>
      ))}
    </>
  );
};
